import React from 'react'
import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'

import { selectors as ChannelsSelectors } from 'data/channels'
import { selectors as ConfigSelectors } from 'data/config'
import { selectors as UserPreferencesSelectors } from 'data/userPreferences'
import { setActiveModal } from 'data/ui/actions'

import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'
import { withFavoriteChannelControls } from './favorite'
import { CHANNEL_SETTINGS } from 'components/Utils/Modal/constants'
import Menu from 'components/Utils/Menu'
import {
  CogIcon,
  PeopleIcon,
  FavoriteEmptyIcon,
  FavoriteIcon,
  EyeIcon,
  EyeCrossedIcon,
  LinkIcon,
  ShareIcon,
} from 'components/Utils/Icons'

const enhance = compose(
  providesUserPreferencesMutations,
  withFavoriteChannelControls,
  connect(
    (state, { channelId }) => {
      const useNewShareTab = ConfigSelectors.hasFlag(
        state,
        'merge-share-and-permissions'
      )
      const channel = ChannelsSelectors.getChannel(state, channelId)

      return {
        channel,
        isMuted: UserPreferencesSelectors.isChannelMuted(state, channelId),
        mutedChannelIds: UserPreferencesSelectors.getMutedChannelIds(state),
        useNewShareTab,
      }
    },
    {
      setActiveModal,
    }
  ),
  withProps(
    ({ channelId, isMuted, updateUserPreferences, mutedChannelIds }) => ({
      onToggleMute() {
        updateUserPreferences({
          mutedChannelIds: isMuted
            ? mutedChannelIds.filter(
                mutedChannelId => mutedChannelId !== channelId
              )
            : mutedChannelIds.add(channelId),
        })
      },
    })
  )
)

export default enhance(function ChannelControlsMenu({
  channelId,
  setActiveModal,
  isMuted,
  onToggleMute,
  isFavorite,
  onToggleFavorite,
  onRowClick,
  showFavoriteControl = true,
  showHideControl = true,
  useNewShareTab = false,
}) {
  const items = [
    {
      icon: CogIcon,
      title: 'Settings',
      action: () => {
        setActiveModal({
          id: CHANNEL_SETTINGS,
          meta: {
            channelId,
            defaultTabId: 'general',
          },
        })
      },
    },
  ]

  if (useNewShareTab) {
    items.push({
      icon: ShareIcon,
      title: 'Share',
      action: () => {
        setActiveModal({
          id: CHANNEL_SETTINGS,
          meta: {
            channelId,
            defaultTabId: 'sharing',
          },
        })
      },
    })
  } else {
    items.push({
      icon: PeopleIcon,
      title: 'Permissions',
      action: () => {
        setActiveModal({
          id: CHANNEL_SETTINGS,
          meta: {
            channelId,
            defaultTabId: 'users',
          },
        })
      },
    })
    items.push({
      icon: LinkIcon,
      title: 'Share this channel',
      action: () => {
        setActiveModal({
          id: CHANNEL_SETTINGS,
          meta: {
            channelId,
            defaultTabId: 'sharing',
          },
        })
      },
    })
  }

  if (showHideControl) {
    items.push({
      icon: isMuted ? EyeIcon : EyeCrossedIcon,
      title: `${isMuted ? 'Unhide' : 'Hide'} channel`,
      action: () => onToggleMute(),
    })
  }

  if (showFavoriteControl) {
    items.push({
      icon: isFavorite ? FavoriteEmptyIcon : FavoriteIcon,
      title: `${isFavorite ? 'Unfavorite' : 'Favorite'} channel`,
      action: () => onToggleFavorite(),
    })
  }

  return <Menu onRowClick={onRowClick} items={items} />
})
